import { Close } from '@mui/icons-material';
import { Stack, SxProps, Theme, Typography } from '@mui/material';

import Button from 'domains/core/components/Button';
import theme from 'theme';

const previewContentBase = {
    border: `${theme.spacing(0.25)} solid ${theme.palette.primary.main}`,
    borderRadius: '6px',
    boxShadow: `${theme.spacing(0.125)} ${theme.spacing(0.125)} 0 ${theme.palette.primary.main}`,
    height: '100%',
    direction: 'column',
    overflow: 'hidden',
};

export type ContentPreviewProps = {
    isOpen: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    isCloseEnabled?: boolean;
    isGridItem?: boolean;
    previewLabel?: string;
    sx?: SxProps<Theme>;
};

const ContentPreview = ({
    isOpen,
    onClose,
    children,
    isCloseEnabled = true,
    isGridItem = false,
    previewLabel = 'content preview',
    sx,
}: ContentPreviewProps) => {
    if (!isOpen) return null;

    return (
        <Stack
            bgcolor="#fff"
            height="100%"
            width="100%"
            zIndex={isOpen ? 100 : -1}
            component={isGridItem ? 'div' : undefined}
            sx={sx}
        >
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5} px={1}>
                <Typography variant="buttonSmall" color="action.active">
                    {previewLabel}
                </Typography>

                {isCloseEnabled && (
                    <Button variant="text" size="small" endIcon={<Close />} onClick={onClose}>
                        close preview
                    </Button>
                )}
            </Stack>

            <Stack sx={previewContentBase}>{children}</Stack>
        </Stack>
    );
};

export { previewContentBase };
export default ContentPreview;
